const $ = require("jquery");

class QuoteCarouselSlides {
	constructor(id) {
		this.$el = $(id);

		$(document).on(
			"verticalChanged",
			(e, verticalSlug) => this.onVerticalChanged(verticalSlug)
		);
	}

	getVertical () {
		return this.$el.attr("data-vertical")
	}

	onVerticalChanged (verticalSlug) {
		if (verticalSlug === this.getVertical()) {
			this.$el.removeClass("hidden");
		} else {
			this.$el.addClass("hidden");
		}
	}
}

module.exports = QuoteCarouselSlides;
